import axios from "axios";
import constants from "./Constants";
import { TokenService } from "./StorageServices";

const ApiService = {
    init(baseURL) {
        //axios.defaults.baseURL = `https://${process.env.REACT_APP_BASE_URL}/server/api/v1/`;
        axios.defaults.baseURL = `https://www.pctflex.com/server/api/v1/`;
        //axios.defaults.baseURL = `http://192.168.0.115:2024/server/api/v1/`;
    },

    setHeader() {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${TokenService.getToken()}`;
    },

    removeHeader() {
        axios.defaults.headers.common = {};
    },

    get(resource) {
        return axios.get(resource);
    },

    blobGet(resource, data) {
        return axios.get(resource, data);
    },


    post(resource, data) {
        return axios.post(resource, data);
    },

    patch(resource, data) {
        return axios.patch(resource, data);
    },

    delete(resource) {
        return axios.delete(resource);
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return axios(data);
    },
};

export default ApiService;
